import { MissingObject } from "./Missing.error";

export class ValidationError extends Error {
  public readonly name: string = "MissingError";
  public object: MissingObject;
  public field: string;
  public value: string;

  constructor(
    message: string,
    object: MissingObject,
    field: string,
    value: string
  ) {
    super(message);
    this.object = object;
    this.field = field;
    this.value = value;
  }
}
